




































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import MallConfig from '@/api/mall/mallConfig/index'
import EditorCustomize from '@/components/editorCustomize/index.vue'
@Component({
  components: {
    EditorCustomize
  }
})
export default class MemberAgreementSetting extends AbpBase {
  key: string = ''
  title: string = ''
  AgreementConfig = {
    Title: null,
    Content: null
  }
  contentTitle: string = ''

  ruleMemberAgreementConfig = {
    Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
    Content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
  }
  mounted() {
    var meta = this.$route.meta
    if (meta.data) {
      this.key = meta.data
    }
    if (meta.title) {
      this.title = meta.title
    }
    if(meta.data === 'SizeGroupConfig') {
      this.contentTitle = '尺码指南'
    }else {
      this.contentTitle = '协议标题'
    }
    this.getConfig()
  }

  /**
   * 获取设置
   */
  getConfig() {
    MallConfig.getMallConfig(this.key).then(res => {
      if (res.data) {
        this.AgreementConfig = res.data
      }
    })
  }

  editorChange(e) {
    this.AgreementConfig.Content = e
  }

  /**
   * 会员协议设置
   */
  MemberAgreementSubmit() {
    let vm = this
    let MemberAgreementConfig: any = vm.$refs.MemberAgreementConfig
    MemberAgreementConfig.validate(valid => {
      if (valid) {
        MallConfig.updateMallConfig(
          this.key,
          this.title,
          vm.AgreementConfig
        ).then(res => {
          vm.$Notice.success({
            desc: '提交成功'
          })
          vm.getConfig()
        })
      }
    })
  }
}
